import Game from "../components/Game";

const Play = (props) => {

    return (<div>
        <Game/>
    </div>)
}

export default Play;